import { render, staticRenderFns } from "./ViewSuspensionsView.vue?vue&type=template&id=57c1613c&"
import script from "./ViewSuspensionsView.vue?vue&type=script&lang=js&"
export * from "./ViewSuspensionsView.vue?vue&type=script&lang=js&"
import style0 from "./ViewSuspensionsView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports